module.exports = __webpack_public_path__ + "img/1.59843c36.jpg";